// extracted by mini-css-extract-plugin
module.exports = {"metadataBarContainer":"_30gpNOc8","articlesInTag":"_2Wa2pMNj"};